export const iconStyles = {
    primary: 'text-white',
    danger: 'text-tt-red-500',
}